if (!customElements.get('tab-box')) {
  class TabBox extends HTMLElement {
    constructor() {
      super();
    }

    init() {
      this.tabButtons = this.querySelectorAll('tab-list button[type="button"]');
      this.tabPanels = this.querySelectorAll('tab-panel');

      this.tabButtons.forEach((tabItem, index) => {
        tabItem.addEventListener('click', (event) => {
          this.handleTabClick(index);
        });
      });
    }

    handleTabClick(index) {
      this.tabButtons.forEach((tabButton, tabIndex) => {
        tabButton.setAttribute('aria-selected', 'false');
        tabButton.setAttribute('tabindex', '-1');
        if (index === tabIndex) {
          tabButton.setAttribute('aria-selected', 'true');
          tabButton.setAttribute('tabindex', '0');
        }
      });

      // Set inactive panels to hidden
      [...this.tabPanels]
        .filter((panel, panelIndex) => panelIndex != index)
        .forEach((panel) => {
          panel.setAttribute('aria-hidden', 'true');
          panel.setAttribute('hidden', 'true');
        });
      // Set active panel to visible
      [...this.tabPanels][index].setAttribute('aria-hidden', 'false');
      [...this.tabPanels][index].setAttribute('hidden', 'false');

      //
    }

    /**
     * description: Invoked when the custom element is first connected to the document's DOM.
     */
    connectedCallback() {
      this.init();
    }
  }
  customElements.define('tab-box', TabBox);
}
